'use strict';

frontendApp.directive('iioHref', ['$location', 'LayerService', 'ResourceService', 'CursorService', 'TrackService', function ($location, LayerService, ResourceService, CursorService, TrackService) {

  var resourceRegex = new RegExp('^(#!)?\/project\/([^\/]*)\/collection\/([^\/]*)\/resource\/([^\/]*)$');

  return {
    restrict: 'A',
    replace: false,

    /*
    template: '<a class="iio-href" href="javascript:void(0)" ng-click="onClick()" ng-transclude></a>',
    transclude: true,
    */

    scope: false,
    link: function (scope, element, attrs) {

      var isResourceLink = (attrs.layer == LayerService.LAYERS.RESOURCE);
      var isMainLink = (attrs.layer == LayerService.LAYERS.MAIN);
      var isSearchLink = (attrs.layer == LayerService.LAYERS.SEARCH);

      var resourceCfg = {
        projectId: null,
        collectionId: null,
        resourceId: null
      };

      element.addClass("iio-href");
      attrs.$set('href', 'javascript:void(0)');

      attrs.$observe('iioHref', function (value) {
        if (!value) return;
        if (isResourceLink) {

          // No real href for resources
          attrs.$set('href', '');

          // #!/project/:projectId/collection/:collectionId/resource/:resourceId
          var match = value.match(resourceRegex);
          if (match) {
            resourceCfg.projectId = match[2];
            resourceCfg.collectionId = match[3];
            resourceCfg.resourceId = match[4];
          }

        } else {
          attrs.$set('href', value);
        }
      });

      //scope.onClick = function() {
      element.bind('click', function () {
        if (isResourceLink) {
          if (!_.has(attrs, 'cursorDetached')) {
            CursorService.setViewing(scope.$index);
          }

          ResourceService.LaunchFullView(resourceCfg);
        } else {
          if (LayerService.getTopLayer() == attrs.layer) {

          } else if (isMainLink) {
            LayerService.popToMain();
          } else {
            LayerService.pushLayer(attrs.layer);
          }
        }
      });

    }
  }
}]);

